import React ,{useState} from 'react';
import styled from 'styled-components';  
import { useSelector } from 'react-redux';
import appInfoContainer from '../../auth/appInfoContainer';





export default function CommentBar(props) {
    const userInfo = useSelector(state=>{ return state.userInfo}); 

    // const [value,setValue]= useState("");
    const [rows,setRows]= useState(1);
    const minRows = 1;
    const maxRows = 5; 

    const handleChange = (event) => {
		const textareaLineHeight = 24;
		
		const previousRows = event.target.rows;
        event.target.rows = minRows; // reset number of rows in textarea 
		
		const currentRows = ~~(event.target.scrollHeight / textareaLineHeight);
    
    if (currentRows === previousRows) {
    	event.target.rows = currentRows;
    }
		
		if (currentRows >= maxRows) {
			event.target.rows = maxRows;
			event.target.scrollTop = event.target.scrollHeight;
		}
        // setValue(event.target.value);
        props.setReplycontent(event.target.value);
        setRows(currentRows < maxRows ? currentRows : maxRows);
	};

    return (
        <MainfixbarInner>
            <User><Images src={appInfoContainer.imagePath +"/user_profile_img/"+userInfo.profile_img}/></User>
            <Textbox>
                <Txtlist>
                    <Nickname >{props.nickname === "" ? "" : `@${props.nickname}`}</Nickname>
                    <TextboxInput  
                        rows={rows}
                        value={props.replycontent}
                        className={'textarea'}
                        onChange={(event) => handleChange(event)}
                        type="text" placeholder="댓글을 달아주세요 :)"
                        ref={props.inputRef}
                    />
                </Txtlist>
                <TextboxSubmit onClick={props.submitCommentRequest} type="submit" value="작성"></TextboxSubmit>
            </Textbox>
        </MainfixbarInner>
    )
}
const Images = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`
const MainfixbarInner = styled.div`
    position: fixed;
    left:0;
    bottom:0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    bottom: 0;
    left: 0;
    width: 100%;
    min-height: calc(100vw*(69/375));
    height:auto;
    background-color: #ffefce;
    padding : calc(100vw*(15/375)) calc(100vw*(17/375)) calc(100vw*(14/375)) calc(100vw*(16/375));
`
const User = styled.p`
    width: calc(100vw*(40/375));
    height: calc(100vw*(40/375));
    border-radius:50%;
    overflow:hidden;
    border: solid calc(100vw*(1/375)) #c6c6c6;
`
const Textbox = styled.div`
    width: calc(100vw*(295/375));
    min-height: calc(100vw*(40/375));
    height:auto;
    border-radius: calc(100vw*(22/375));
    border: solid calc(100vw*(1/375)) #888888;
    margin-left: calc(100vw*(7/375));
    padding : 0 calc(100vw*(17/375)) 0 calc(100vw*(19/375));
    display: flex;
    align-items: center;
    justify-content: space-between;
`
const Txtlist = styled.div`
    display: flex;
    align-items: center;
    width: 90%;
    height:100%;
`
const TextboxInput = styled.textarea`
    background: none;
    width: 87%;
    font-size: calc(100vw*(14/375));
    color: #1d1d1d;
    line-height: calc(100vw*(24/375));
`
const TextboxSubmit = styled.input`
    font-size: calc(100vw*(14/375));
    font-weight: 500;
    color: #ff8900;
    background: none;
`
const Nickname = styled.a`
    font-weight: 500;
    font-size:  calc(100vw*(14/375));
    color: #ff8900;
    width: auto;
    max-width: calc(100vw*(66/375));
    overflow: hidden; text-overflow: ellipsis; white-space: nowrap
`